// تنسيق المبالغ والتواريخ داخل تقرير الرواتب.
export const formatCurrency = (value, currency) => {
  const num = Number(value || 0);
  const body = num.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  return `${body} ${currency || ""}`.trim();
};

export const shortDate = (iso) => (iso || "").slice(5).replace("-", "/");

export const firstFive = (dates = []) => {
  const shown = dates.slice(0, 5);
  return { shown, more: dates.length > 5 };
};

export const esc = (value) =>
  String(value ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

export const today = () => new Date().toISOString().slice(0, 10);
